"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var Layout = function Layout(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    action = _ref.action,
    children = _ref.children,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex flex-col p-8",
    style: {
      minHeight: 400
    }
  }, onClose && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right text-medium hover:opacity-75 -mt-4 -mr-4"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), (title || subtitle) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-6"
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark text-xl font-bold mb-2"
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-medium font-bold"
  }, subtitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col flex-1 overflow-auto"
  }, children), action && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex pt-8"
  }, _react["default"].Children.map(action, function (node, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mx-2 first:ml-0 last:mr-0"
    }, /*#__PURE__*/_react["default"].cloneElement(node, {
      className: 'w-32'
    }));
  })));
};
var _default = exports["default"] = Layout;
//# sourceMappingURL=Layout.js.map